export default "__VITE_ASSET__DaSTKMxq__"